<div class="container-fluid pt-4 h-100">
  <div class="pre-processing-container h-100 d-flex flex-column">
    <div class="header d-flex justify-content-center flex-column">
      <span class="header-5">Segmentation Threshold</span>
    </div>
    <div class="card-body">
      <div class="pb-2">
      <span class="w-100 accello-general-text12">Ensure all checkboxes are selected to proceed. </span>
      </div>
      <div *ngIf="records && !isLoading" class="col-md-12 segmentation">
        <app-zorro-table
          tableId="segm-thrsld"
          [columns]="records?.columns"
          [data]="records?.rows"
          (onRowSelect)="handleRowSelection($event)"
          [options]="options"
          class="w-100"
        ></app-zorro-table>
      </div>
      <div
        *ngIf="isLoading"
        class="loader-content d-flex flex-column justify-content-center"
      >
        <app-loading [text]="'Loading...'"></app-loading>
      </div>
    </div>
    <div class="footer d-flex justify-content-end">
      <button class="btn-accello-primary-outlined align-items-center mx-2" (click)="goBack()">Back</button>
      <button
        class="btn btn-accello-primary mx-2 btn-spin" [disabled]="isDisabled"
        (click)="segmentationProcess()"
      >
        <span>Next</span>
          @if(isProcessing){
          <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
          }
      </button>
    </div>
  </div>
</div>
